import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Card from 'shared/lib/components/Card';
import CardSectionHeading from '../CardSectionHeading';
import PolicyRow from '../PolicyRow';
import Spinner from 'shared/lib/components/Spinner';
import VERTICALS from 'shared/lib/constants/verticals';
import { Link } from 'react-router';
import filter from 'lodash/filter';
import moment from 'moment-timezone';
import map from 'lodash/map';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import toPairs from 'lodash/toPairs';
import * as analytics from 'shared/lib/analytics';
import './PoliciesForVerticalView.css';

const propTypes = {
  getPoliciesForVertical: PropTypes.func,
  policiesById: PropTypes.object,
  params: PropTypes.shape({
    verticalCode: PropTypes.string,
  }).isRequired,
  policiesTotalsByVertical: PropTypes.object,
  isFetchingPolicies: PropTypes.bool,
};

const defaultProps = {
  policiesById: {},
  policiesTotalsByVertical: {},
  isFetchingPolicies: false,
};

class PoliciesForVerticalView extends PureComponent {
  componentDidMount() {
    document.title = `Your ${VERTICALS[
      this.props.params.verticalCode
    ].title.toLowerCase()} policies | Sure`;
    this.props.getPoliciesForVertical(this.props.params.verticalCode);
    analytics.page('Policy Management - Policy List');
  }

  get policiesNodes() {
    const policies = filter(this.props.policiesById, {
      vertical_code: this.props.params.verticalCode,
    });
    const policiesByDay = groupBy(policies, policy => {
      return policy.created.split('T')[0];
    });
    const sortedPoliciesByDayPairs = sortBy(toPairs(policiesByDay), pair => {
      return -moment(pair[0], 'YYYY-MM-DD').valueOf();
    });

    return map(sortedPoliciesByDayPairs, tuple => {
      const [date, policies] = tuple;
      return [
        <CardSectionHeading key={date}>
          Purchased on {moment(date, 'YYYY-MM-DD').format('MMM D, YYYY')}
        </CardSectionHeading>,
        map(policies, policy => (
          <PolicyRow
            key={policy.id}
            policyId={policy.id}
            icon={VERTICALS[policy.vertical_code].icon}
            withBadge
            createdAt={policy.created}
            verticalCode={policy.vertical_code}
            underwriter={policy.underwriter.name}
            details={policy.details}
            status={policy.status}
          />
        )),
      ];
    });
  }

  get statusNode() {
    return this.props.isFetchingPolicies ? (
      <Spinner />
    ) : (
      `(${this.props.policiesTotalsByVertical[this.props.params.verticalCode]})`
    );
  }

  render() {
    return (
      <div className="PoliciesForVerticalView Container">
        <Link
          className="PoliciesForVerticalView-backLink"
          to="/account/policies"
        >
          <span className="material-icons">arrow_back</span> Back
        </Link>
        <h1 className="PoliciesForVerticalView-heading">
          {VERTICALS[this.props.params.verticalCode].title} policies{' '}
          {this.statusNode}
        </h1>
        <Card>{this.policiesNodes}</Card>
      </div>
    );
  }
}

PoliciesForVerticalView.propTypes = propTypes;
PoliciesForVerticalView.defaultProps = defaultProps;

export default PoliciesForVerticalView;
